<template>
  <!-- <page :load="doInit"> -->
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs6 md7 lg9>
          <card-menu :items="cardMenu" @cardReturn="allowCnvPolCtrl" subMenu></card-menu>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <!--lcd_20201202-->
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark small color="teal" v-on="on" @click.native.stop="showFilterList = true">
                          <v-icon dark>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                      </template>
                      <span>Show Saved Filters</span>
                    </v-tooltip>
                    {{ filtersTitle }}
                    <span class="caption grey--text font-weight-light">
                      {{ defaultFilter.filterName !== undefined ? ' (' + defaultFilter.filterName + ')' : '' }}</span
                    >
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            :items="propTypeList"
                            v-model="filters.propType"
                            :label="filtersLabel.propType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="propType"
                            :data-vv-as="filtersLabel.propType"
                            :error-messages="errors.collect('propType')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg8></v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.propNo"
                            :label="filtersLabel.propNo"
                            :error-messages="errors.collect('propNo')"
                            data-vv-name="propNo"
                            :data-vv-as="filtersLabel.propNo"
                            v-validate="'entry|max:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <cal-picker
                            v-model="filters.propDate"
                            :label="filtersLabel.propDate"
                            :data-vv-as="filtersLabel.propDate"
                            data-vv-name="propDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.name1"
                            :label="filtersLabel.name1"
                            :error-messages="errors.collect('name1')"
                            data-vv-name="name1"
                            :data-vv-as="filtersLabel.name1"
                            v-validate="'entry|max:50'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            :items="propStatList"
                            v-model="filters.propStat"
                            :label="filtersLabel.propStat"
                            item-text="label"
                            item-value="value"
                            data-vv-name="propStat"
                            :data-vv-as="filtersLabel.propStat"
                            :error-messages="errors.collect('propStat')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.polNo1"
                            :label="filtersLabel.polNo1"
                            :error-messages="errors.collect('polNo1')"
                            data-vv-name="polNo1"
                            :data-vv-as="filtersLabel.polNo1"
                            v-validate="'entry|max:16'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.ipcNo"
                            :label="filtersLabel.ipcNo"
                            :error-messages="errors.collect('ipcNo')"
                            data-vv-name="ipcNo"
                            :data-vv-as="filtersLabel.ipcNo"
                            v-validate="'entry|max:10'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.native="saveFilter = true">Save Current Filters</v-btn>
                    <!--lcd_20201202-->
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-flex class="text-right">
              <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                <template v-slot:activator="{ on }">
                  <div class="text-right mr-2">
                    <v-btn color="secondary" class="white--text" v-on="on">
                      <span>Columns</span>
                      <v-icon right dark>mdi-table-column-plus-after</v-icon>
                    </v-btn>
                  </div>
                </template>
                <v-card>
                  <v-card-text>
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else>No column found</template>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  :headers="listHeaders"
                  :items="items"
                  :server-items-length="totalItems"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="pagination"
                  item-key="polNo"
                  :loading="loading"
                  :no-data-text="noDataText"
                  :custom-filter="customSearch"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectedColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action
                          :rowData="row"
                          :review="canReview(row) && checkAccess([permissionKeys.perm_016015])"
                          @review="doReview(row.item) && checkAccess([permissionKeys.perm_016015])"
                          :query="canQuery(row) && checkAccess([permissionKeys.perm_016020])"
                          @query="doQuery(row.item) && checkAccess([permissionKeys.perm_016020])"
                          copyText="View"
                          :copy="canConvert(row) && checkAccess([permissionKeys.perm_016040])"
                          @copy="doConvert(row.item) && checkAccess([permissionKeys.perm_016040])"
                          :loading="loading"
                        ></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-card>
        </v-flex>
        <!--lcd_20201202-->
        <v-dialog v-model="showFilterList" width="800px" persistent>
          <SearchFilter
            :boolRefresh="showFilterList"
            :filterTitle="'Saved Filters - Payment Listing'"
            @close="showFilterList = false"
            :filterCode="filterCode"
            @applyDefaultFilter="applyDefaultFilter"
          ></SearchFilter>
        </v-dialog>
        <v-dialog v-model="saveFilter" width="800px" persistent>
          <UpdateSearchFilter
            :boolRefresh="saveFilter"
            :dialogTitle="'Filter'"
            :actionName="'new'"
            :filters="filters"
            @close="saveFilter = false"
            @reloadList="reloadList"
            :filterCode="filterCode"
            @applyDefaultFilter="applyDefaultFilter"
          ></UpdateSearchFilter>
        </v-dialog>
        <!--end lcd_20201202-->
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import clone from 'clone'
import { listMixin } from '@/mixins/listMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDateTime2, removeTime } from '@/utils/date'
import { propType2 } from '@/const/underwriting'
import { PROPOSAL_REVIEW_MODE, PROPOSAL_QUERY_MODE, PROPOSAL_CONVERT_MODE } from '@/store/types'
import { mapGetters } from 'vuex'
import SearchFilter from '@/components/core/common/dialog/SearchFilter'
import UpdateSearchFilter from '@/components/core/common/dialog/UpdateSearchFilter'
import { permissionKeys } from '@/mixins/global/permissionKey'

export default {
  data() {
    return {
      permissionKeys: permissionKeys,
      cardMenu: [
        { text: 'Proposal', icon: 'mdi-file', name: '', params: { allowCnvPol: false }, access: '', default: true },
        { text: 'Conversion', icon: 'mdi-file-multiple', name: '', params: { allowCnvPol: true }, access: '', default: false }
      ],
      filtersLabel: {
        propType: 'Proposal Type',
        propNo: 'Proposal No.',
        propDate: 'Proposal Date',
        name1: 'Proposal Name',
        propStat: 'Proposal Status',
        polNo1: 'Policy No.',
        ipcNo: 'IPC No.'
      },
      selectedColumns: ['propNo', 'name1', 'propStat', 'propDate', 'polNo1', 'ipcNo'],
      columns: [
        {
          text: 'Proposal No.',
          align: 'left',
          value: 'propNo'
        },
        { text: 'Proposal Name', value: 'name1' },
        { text: 'Proposal Status', value: 'propStat' },
        { text: 'Proposal Date', value: 'propDate' },
        { text: 'Policy No.', value: 'polNo1' },
        { text: 'IPC No.', value: 'ipcNo' },
        { text: 'IPC Sequence No.', value: 'ipcSeqNo' },
        { text: 'Policy No. 2', value: 'polNo2' },
        { text: 'Policy Type', value: 'polType' },
        { text: 'Scheme', value: 'scheme' },
        { text: 'Plan No.', value: 'planNo' },
        { text: 'Branch', value: 'branch' },
        { text: 'Business Source', value: 'busSrc' },
        { text: 'Proposal Name 2', value: 'name2' },
        { text: 'Proposal Name 3', value: 'name3' },
        { text: 'Address', value: 'addr1' },
        { text: 'Address 2', value: 'addr2' },
        { text: 'Address 3', value: 'addr3' },
        { text: 'Address 4', value: 'addr4' },
        { text: 'Postal Code', value: 'postCode' },
        { text: 'Telephone No.', value: 'telNo' },
        { text: 'Mobile No.', value: 'mobileNo' },
        { text: 'Fax No.', value: 'faxNo' },
        { text: 'E-mail', value: 'email' },
        { text: 'Commencement Date', value: 'comDate' },
        { text: 'Expiry Date', value: 'expDate' }
      ],
      filters: {
        propType: 'ALL',
        propNo: null,
        allowCnvPol: false,
        name1: null,
        propStat: null,
        propDate: null,
        polNo1: null,
        ipcNo: null,
        ipcSeqNo: null,
        polNo2: null,
        polType: null,
        scheme: null,
        planNo: null,
        branch: null,
        busSrc: null,
        name2: null,
        name3: null,
        addr1: null,
        addr2: null,
        addr4: null,
        postCode: null,
        telNo: null,
        mobileNo: null,
        faxNo: null,
        email: null,
        comate: null,
        expDate: null
      },
      allowCnvPol: false,
      propStatList: [],
      loading: false,
      filterCode: '',
      newFilter: false,
      saveFilter: false,
      showFilterList: false,
      defaultFilter: {},
      filtersTitle: '',
      pagination: {
        sortDesc: [true],
        page: 1
      },
      isAfterDefFilter: false
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      if (this.isAfterDefFilter === true) {
        this.fetchData(false)
      }
    }
  },
  created() {},
  computed: {
    // lcd_20201202
    ...mapGetters(['checkAccess']),
    initProposalInit() {
      return this.$store.state.proposal.init
    },
    proposalListing() {
      return this.$store.state.proposal.proposalListing
    },
    menu() {
      return this.$store.state.proposal.proposalListing.menu
    },
    propTypeList() {
      let result = []
      Object.keys(propType2).forEach(function (key) {
        const status = propType2[key]
        if (key === 'NULL') {
          result.push({
            label: status,
            value: null
          })
        } else {
          result.push({
            label: status,
            value: key
          })
        }
      })
      return result
    }
  },
  methods: {
    allowCnvPolCtrl(data) {
      this.allowCnvPol = data.allowCnvPol
      this.filters.allowCnvPol = data.allowCnvPol
      // lcd_20201202
      if (data.allowCnvPol) {
        this.filterCode = 'CON'
        this.filtersTitle = 'Filters for Conversion'
      } else {
        this.filterCode = 'PRO'
        this.filtersTitle = 'Filters for Proposal'
      }
      this.doInit()
    },
    canReview(data) {
      if (this.allowCnvPol || !data.item.perRev) {
        return false
      } else {
        return true
      }
    },
    canQuery(data) {
      if (this.allowCnvPol) {
        return false
      } else {
        return true
      }
    },
    canConvert(data) {
      if (this.allowCnvPol) {
        return true
      } else {
        return false
      }
    },
    async doReview(data) {
      this.resetMessages()
      this.loading = true
      this.$store.commit(PROPOSAL_REVIEW_MODE)
      this.$store.dispatch('reviewProposal', data).then(() => {
        this.$router.push({ name: 'reviewProposal' })
        this.loading = false
      })
    },
    async doQuery(data) {
      this.resetMessages()
      this.loading = true
      this.$store.commit(PROPOSAL_QUERY_MODE)
      this.$store.dispatch('reviewProposal', data).then(() => {
        this.$router.push({ name: 'queryProposal' })
        this.loading = false
      })
    },
    async doConvert(data) {
      this.resetMessages()
      this.loading = true
      this.$store.commit(PROPOSAL_CONVERT_MODE)
      this.$store.dispatch('reviewProposal', data).then(() => {
        this.$router.push({ name: 'convertProposal' })
        this.loading = false
      })
    },
    async doInit() {
      await Promise.all([this.$store.dispatch('proposalInit')])
      await Promise.all([this.$store.dispatch('searchFilterInit')]) // lcd_20201202
      if (this.initProposalInit === 1) {
        await this.$store.dispatch('proposalListingInit')
        await this.$store.dispatch('proposalDetailsInit')
        await this.$store.dispatch('coverageDetailsInit')
        this.getDefaultFilter() // lcd_20201202
        this.fetchData()
        this.getPropStatList()
      }
      this.cardMenu = []
      if (this.checkAccess([permissionKeys.perm_016010]) === true) {
        this.cardMenu.push({ text: 'Proposal', icon: 'mdi-file', name: '', params: { allowCnvPol: false }, access: '', default: true })
      }
      if (this.checkAccess([permissionKeys.perm_016030]) === true) {
        this.cardMenu.push({ text: 'Conversion', icon: 'mdi-file-multiple', name: '', params: { allowCnvPol: true }, access: '', default: false })
      }
    },
    async fetchData(card) {
      let apiUrl = this.$store.state.proposal.proposalListing.menu.getProposalList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.propType === 'ALL') {
            massageFilters.propType = null
          }
          if (massageFilters.propDate) {
            massageFilters.propDate = formatDisplayDateTime2(removeTime(massageFilters.propDate))
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.items = []
              data.map((proposal) => {
                const convertProposal = {
                  propNo: proposal.propNo,
                  name1: proposal.name1,
                  propStat: proposal.propStat,
                  propDate: this.formatDate(proposal.propDate),
                  polNo1: proposal.polNo1,
                  ipcNo: proposal.ipcNo,
                  ipcSeqNo: proposal.ipcSeqNo,
                  polNo2: proposal.polNo2,
                  polType: proposal.polType,
                  scheme: proposal.scheme,
                  planNo: proposal.planNo,
                  branch: proposal.branch,
                  busSrc: proposal.busSrc,
                  name2: proposal.name2,
                  name3: proposal.name3,
                  addr1: proposal.addr1,
                  addr2: proposal.addr2,
                  addr3: proposal.addr3,
                  addr4: proposal.addr4,
                  postCode: proposal.postCode,
                  telNo: proposal.telNo,
                  mobileNo: proposal.mobileNo,
                  faxNo: proposal.faxNo,
                  email: proposal.email,
                  comDate: this.formatDate(proposal.comDate),
                  expDate: this.formatDate(proposal.expDate),
                  perRev: proposal.perRev
                }
                this.items.push(convertProposal)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getPropStatList() {
      const apiURI = this.menu.getPropStatList
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            allowCnvPol: this.allowCnvPol
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.propStatList = []
          if (data) {
            this.loading = false
            data.propStatList.map((propStat) => {
              const convertList = {
                value: propStat.value,
                label: propStat.label
              }
              this.propStatList.push(convertList)
            })
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearFilters() {
      this.filters.propType = 'ALL'
      this.filters.propNo = null
      this.filters.propDate = null
      this.filters.name1 = null
      this.filters.propStat = null
      this.filters.polNo1 = null
      this.filters.ipcNo = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    // lcd_20201202
    reloadList(filterName) {
      this.defaultFilter.filterName = filterName
      this.saveFilter = false
      this.fetchData(false)
    },
    applyDefaultFilter(filterData) {
      this.defaultFilter = filterData
      if (this.defaultFilter.filters !== undefined) {
        this.filters = this.defaultFilter.filters
      }
      this.showFilterList = false
      this.fetchData(false)
    },
    async getDefaultFilter() {
      const apiUrl = this.$store.state.searchFilter.menu.defaultFilter
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            filterCode: this.filterCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.initialLoad = false
          if (data) {
            this.defaultFilter.filterName = data.defaultFilter.filterName
            this.defaultFilter.filterDesc = data.defaultFilter.filterDesc
            this.defaultFilter.filterCode = data.defaultFilter.filterCode
            this.defaultFilter.filters = JSON.parse(data.defaultFilter.filterContent)
            if (this.defaultFilter.filters !== undefined) {
              this.filters = this.defaultFilter.filters
            }
            this.fetchData(false)
          } else {
            this.fetchData(false)
          }
          this.isAfterDefFilter = true
        } catch (err) {
          this.loading = false
        }
      }
    }
    // end lcd_20201202
  },
  mixins: [listMixin, MessageMixin],
  components: {
    SearchFilter,
    UpdateSearchFilter
  } // lcd_20201202
}
</script>
